import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';
import { Offcanvas } from 'react-bootstrap';
const TenantModal = ({ showModal, handleClose, activityId, activityData, addActivity, editActivity, industries, instances, errors, setErrors }) => {
  const [loading, setLoading] = useState(false); // Track loading state

  const [activityTypes, setActivityTypes] = useState([]);
  const [formData, setFormData] = useState({
    lead_id: '',
    status: '',
    activity_type: '',
    activity_type_id: '',
    priority: '',
    notes: '',
    subject: '',
    due_date: '',
    reminder_at: '',
    reminder_type: 'both',
    user_id: '',
  });

  const [users, setUsers] = useState([]);
  const [remindMeOption, setRemindMeOption] = useState('');


  const fetchActivityTypes = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');
      const token = userInfo?.token;

      const response = await axios.get(`${backendUrl}/api/activity-types`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
        skipLoader: true,

      });
      setActivityTypes(response.data.data);
    } catch (error) {
      console.error("Error fetching activity types:", error);
    }
  };

  const fetchUsers = async () => {
    try {
      const backendUrl = process.env.REACT_APP_BACKEND_URL;
      const userInfo = JSON.parse(localStorage.getItem('user-info'));
      const origin = localStorage.getItem('user-origin');
      const token = userInfo?.token;

      const response = await axios.get(`${backendUrl}/api/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Tenant-Origin': origin,
        },
        skipLoader: true,

      });
      setUsers(response.data.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchActivityTypes();
    fetchUsers();
  }, []);

  useEffect(() => {
    if (activityId && activityData) {
      setFormData({
        ...activityData,
        activity_type_id: activityData.activity_type_id || '',
        reminder_at: activityData.reminder_at || '',
        reminder_type: activityData.reminder_type || 'both',
      });
    } else if (showModal && !activityData) {
      setFormData({
        due_date: '',
        reminder_at: '',
        reminder_type: 'both',
        user_id: JSON.parse(localStorage.getItem('user-info'))?.user?.id || '',
      });
      setRemindMeOption('');
    }
  }, [activityId, activityData, showModal]);

  const calculateReminder = (option, dueDate) => {
    if (!dueDate || !option) return;

    const date = new Date(dueDate);
    // Due date is usually just date (00:00). Set to a standard follow-up time (e.g., 9:00 AM)
    date.setHours(9, 0, 0, 0);

    let reminderDate = new Date(date);

    switch (option) {
      case '15mins': reminderDate.setMinutes(date.getMinutes() - 15); break;
      case '1hour': reminderDate.setHours(date.getHours() - 1); break;
      case '1day': reminderDate.setDate(date.getDate() - 1); break;
      case '5days': reminderDate.setDate(date.getDate() - 5); break;
      default: return;
    }

    // Format to YYYY-MM-DDTHH:mm
    const tzOffset = reminderDate.getTimezoneOffset() * 60000;
    const localISOTime = new Date(reminderDate - tzOffset).toISOString().slice(0, 16);

    setFormData(prev => ({ ...prev, reminder_at: localISOTime }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'due_date' && remindMeOption) {
      calculateReminder(remindMeOption, value);
    }

    if (errors[name]) {
      setErrors(prevErrors => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleRemindMeChange = (e) => {
    const value = e.target.value;
    setRemindMeOption(value);
    calculateReminder(value, formData.due_date);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start the button-specific loader

    try {
      let errors;
      if (activityId) {
        // Edit tenant
        errors = await editActivity(activityId, formData);
      } else {
        // Add new tenant
        errors = await addActivity(formData);
      }
      if (errors && Object.keys(errors).length > 0) {
        setErrors(errors); // Display validation errors
      } else {
        setErrors({}); // Clear errors on success
        handleClose(); // Close modal on success
      }
    } catch (error) {
      console.error("An error occurred:", error); // Log any unexpected errors
    } finally {
      setLoading(false); // Stop the button-specific loader
    }
  };

  return (
    <>





      <Offcanvas
        show={showModal}
        onHide={handleClose}
        placement="end"
        style={{ width: '550px' }}
        enforceFocus={false}
        autoFocus={false}
        restoreFocus={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{activityId ? 'Edit Activity' : 'Create Activity'}</Offcanvas.Title>
        </Offcanvas.Header>
        <hr style={{ margin: 0 }} /><br />

        <Offcanvas.Body>
          <Form>

            <Form.Group controlId="subject" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Subject</Form.Label>
              <Form.Control
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
              />
            </Form.Group>

            {/* <Form.Group controlId="user_id" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Assigned To</Form.Label>
              <Form.Select
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                name="user_id"
                value={formData.user_id}
                onChange={handleChange}
              >
                <option value="">Select User</option>
                {users.map(user => (
                  <option key={user.id} value={user.id}>{user.name}</option>
                ))}
              </Form.Select>
            </Form.Group> */}
            <Form.Group controlId="activity_type_id" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Activity Type</Form.Label>
              <Form.Select
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                name="activity_type_id"
                value={formData.activity_type_id}
                onChange={handleChange}
              >
                <option value="">Select</option>
                {activityTypes.map(type => (
                  <option key={type.id} value={type.id}>{type.name}</option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="priority" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Priority</Form.Label>
              <Form.Select
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                name="priority"
                value={formData.priority}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="high">High</option>
                <option value="low">Low</option>
                <option value="normal">Normal</option>
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="due_date" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Due Date</Form.Label>
              <Form.Control
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                type="date"
                name="due_date"
                value={formData.due_date}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="remind_me" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Remind Me</Form.Label>
              <Form.Select
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                value={remindMeOption}
                onChange={handleRemindMeChange}
              >
                <option value="">Select Lead Time</option>
                <option value="15mins">15 Minutes Before</option>
                <option value="1hour">1 Hour Before</option>
                <option value="1day">1 Day Before</option>
                <option value="5days">5 Days Before</option>
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="reminder_at" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Reminder Date & Time</Form.Label>
              <Form.Control
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                type="datetime-local"
                name="reminder_at"
                value={formData.reminder_at}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="reminder_type" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Reminder Type</Form.Label>
              <Form.Select
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                name="reminder_type"
                value={formData.reminder_type}
                onChange={handleChange}
              >
                <option value="both">Both (Email & Popup)</option>
                <option value="email">Email Only</option>
                <option value="popup">Popup Only</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3" >
              <Form.Label style={{ fontSize: "13px" }}>Status</Form.Label>
              <Form.Control
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                type="text"
                name="status"
                value={formData.status}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="notes" className="mb-3">
              <Form.Label style={{ fontSize: "13px" }}>Notes</Form.Label>
              <Form.Control
                style={{
                  fontSize: '13px',
                  borderRadius: '14px',
                  height: '39px',
                  border: '0.5px solid rgb(232, 233, 237)',
                }}
                as="textarea"
                rows={3}
                name="notes"
                value={formData.notes}
                onChange={handleChange}
              />
            </Form.Group>

          </Form>
          <br />
          <div className="p-3 d-flex justify-content-end border-top">
            <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
              Close
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading && (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ marginRight: '10px' }}
                  />
                </>
              )}
              Save
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default TenantModal;

